import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import StatusRules from '../../../template/status/statusBlock/StatusRules';
import PreviewVerification from './PreviewVerification';
import FlagCustomisationVerification from '../../../template/flagCostomisationTamplate/FlagCustomisationVerification';
import './vereficationComponent.scss'
import { useChanges } from "../../../../hooks/useChanges";
import {useAdvanceChanges} from '../../../../hooks/useAdvanceChanges'
import { getVerification, getVerificationAdvanced } from '../../../../store/Verification'
import {verificationApi} from '../../../../http/Api'

const StatusVerefication = () => {
    const { handleSaveChanges, cancelChanges } = useChanges();
    const {handleSaveAdvanceChanges, cancelAdvanceChanges} = useAdvanceChanges()
    const { verificationGlobalState, verificationAdvancedGlobalState } = useSelector((state) => state.verification);
    const [selectedValue, setSelectedValue] = useState('Numerical Captcha')
    const { changesDetected } = useSelector((state) => state.changeDetected);
    const { changesAdvanceDetected } = useSelector((state) => state.changeAdvanceDetected);

    useEffect(() => {
        switch (verificationGlobalState?.data?.captchaType) {
            case 'classic':
                setSelectedValue('Classic Captcha')
                break;
            case 'numerical':
                setSelectedValue('Numerical Captcha')
                break;
            case 'images':
                setSelectedValue('Images Captcha')
                break;
            default:
                setSelectedValue('Numerical Captcha')
                break;
        }   
    }, [verificationGlobalState?.data?.captchaType])

    return (
        <div className='setting_component_wrap'>
        <div className='overview_component_content_head'>
            <h4>Logs</h4>
            <p>A centralised location to view and manage logs generated by Discord bots, allowing for easier tracking and troubleshooting of bot activity.</p>
        </div>
        <div className='status_varification_content_wrap' style={{width:'100%'}}>
            <StatusRules
            data={verificationGlobalState}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            />
            <PreviewVerification
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue} />
        { changesDetected && <ChangeDetectedItem cancel={cancelChanges} onSave={()=>handleSaveChanges(verificationApi.updateVerification, getVerification)} />}
        </div>
        <FlagCustomisationVerification
            title={'Advance Settings'}
            text={'In-depth customisation with flexible flag system'}
            data={verificationAdvancedGlobalState?.data}
        />
        { changesAdvanceDetected && <ChangeDetectedItem cancel={cancelAdvanceChanges} onSave={()=>handleSaveAdvanceChanges(verificationApi.updateVerificationAdvanced, getVerificationAdvanced)} />}
        
    </div>
    );
};

export default StatusVerefication;